import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'mastery-competency-completion-setting',
    components: {

    },
})

export default class MasteryCompetencyCompletionSetting extends Vue {

    // -----------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    @Prop()
    private isReadOnly: any;

    @Prop()
    private tenantSettings: any;

    @Prop()
    private categorySubjectData: any;

    @Prop()
    private value: any;

    @Prop()
    private defaultMinScore: any;

    private updateConfig: any = {};

    private categoryList: any = [];

    private selectedCategory: any = null;

    private defaultInputValue: any = 80;

    private isShowSubject: boolean = false;

    private changesArray: any = [];

    private content: any = {};

    private selectedSubjectArray: any = [];

    private dataStringValue: any = '';

    private dataPropsValues: any = [];

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    // -----------------------------------------------------------------------------------
    // Hooks

    private mounted() {
        if (this.isReadOnly) {
            this.content = this.value;
            if (this.categorySubjectData && this.categorySubjectData.length > 0) {
                this.fetchDisplayPropParent();
            }
        } else {
            this.fetchCategoryLists();
        }
    }

    // -----------------------------------------------------------------------------------
    // Actions

    private onSelectConfig(selectedCategory: any) {
        this.$emit('onChangeConfig', this.updateConfig);
    }

    private onSelectCategory(category: any) {
        this.selectedCategory = category;
        this.subjectLists(category);
    }

    private onSelectSubject(event: any, subject: any, index: any) {
        const childElement: any = (event.target.parentElement as HTMLElement).querySelector('.framework-blk');
        this.$el.querySelectorAll('.framework-blk').forEach((element, queryindex) => {
            if (element !== event) {
                if (queryindex === index) {
                    if ((element as HTMLElement).style.display === 'none' || (element as HTMLElement).style.display === '') {
                        (element as HTMLElement).style.display = 'block';
                    } else {
                        (element as HTMLElement).style.display = 'none';
                    }
                } else {
                    (element as HTMLElement).style.display = 'none';
                }
            }
        });
    }


    // ---------------------------------------------------------------------------------
    // Methods

    private subjectLists(category: any) {
        taxonomyAPI.fetchSubjects(category.id).then((subjects) => {
            this.$set(this.selectedCategory, 'subjectList', subjects);
            // this.selectedCategory.subjectList = subjects;
        });
    }

    private fetchCategoryLists() {
        taxonomyAPI.fetchTaxonomyClassifications().then((classification: any) => {
            this.categoryList = classification;
        });
    }

    private changesDetected(framework: any, subject: any, fIndex: any) {
        const sub: any = {};
        sub[subject.code] = {
            framework: framework.standard_framework_id,
            percent_completion: subject.frameworks[fIndex].value,
        };
        this.$emit('input', sub);
    }

    private selectedframeWork(subject: any, framework: any) {
        this.$set(subject, 'selectedFw', framework.taxonomy_subject_id);
    }

    private async fetchDisplayPropParent() {
        const categoryList = this.categorySubjectData;
        // const valueData: any = { "CCSS.K12.MA": 80, "TNM.K12.MA": 75, "SC.HE.CS":60, "GDF.HE.BS":50 };
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    categoryId: propSplit[0],
                    subjectId: prop,
                    frameworkId: valueData[prop].framework,
                    percentCompletion: valueData[prop].percent_completion,
                };
                dataValuesCalculate.push(data);
            }
        }
        this.categoryList = categoryList;
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject.title;
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private makeStringToShow(dataValuesCalculate: any) {
        const dataValue = dataValuesCalculate;
        let emptyString = '';
        for (const iterator of dataValue) {
            emptyString += `${iterator.categoryId} - ${iterator.subjectTitle} | ${iterator.frameworkId} = ${iterator.percentCompletion}%; `;
        }
        this.dataStringValue = emptyString;
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }
}
